import { Component, Input } from '@angular/core';
import { Feature, FeaturePropertyKey, SummaryConsumptionProperties } from '@vi-iot/client/index';
import { FeaturesDetailsOverlayTypeEnum } from '../installation-overlay.model';

@Component({
  selector: 'app-generic-consumption-panel',
  templateUrl: './generic-consumption-panel.component.html',
  styleUrls: ['./generic-consumption-panel.component.scss'],
})
export class GenericConsumptionPanelComponent {
  @Input() title: string;
  @Input() gasConsumptionSummaryHeating: Feature<SummaryConsumptionProperties, never>;
  @Input() gasConsumptionSummaryDhw: Feature<SummaryConsumptionProperties, never>;
  @Input() powerConsumptionSummaryHeating: Feature<SummaryConsumptionProperties, never>;
  @Input() autarkySummary: Feature<SummaryConsumptionProperties, never>;

  @Input() powerConsumptionSummaryDhw: Feature<SummaryConsumptionProperties, never>;
  @Input() overlayType: FeaturesDetailsOverlayTypeEnum;
  @Input() deviceSelectId: string;
  readonly featurePropertyKey = FeaturePropertyKey;
}
